import React, { useContext, useEffect, useState } from 'react'
import { SearchContext } from '../../lib/context/search-context'
import moment from 'moment'
import axios from 'axios'
import Loading from '../loading'
import { filterHotels, mapApiHotels, setBasePrice } from '../../lib/helpers'
import Wrapper from '../layout/grid/wrapper'
import { Container, Grid } from '@material-ui/core'
import classes from '../pages/destinations/destinations.module.scss'
import FilterTabs from '../tabs/filters'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCheck,
  faChevronDown,
  faPlus,
} from '@fortawesome/pro-light-svg-icons'
import Popup from '../popup'
import Filters from '../popups/filters'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import ButtonStyles from '../button-styles'
import ApiContext from '../../utils/api-context'
import Sortable from './sortable'
import { useModal } from '../../lib/context/modal-context'
import Locations from '../maps/locations'
import search from '../../pages/api/search'

const Search = ({
  newSearch,
  hotels,
  filterTypes,
  filterAreas,
  filterTabs,
}) => {
  const { searchParams } = useContext(SearchContext)
  const [results, setResults] = useState([])
  const [loading, setLoading] = useState(true)
  const { t, i18n } = useTranslation()
  const router = useRouter()
  const buttonStyles = ButtonStyles({})
  const [mobile, setMobile] = useState(true)
  const [openFilters, setOpenFilters] = useState(false)
  const [withAccommodation, setWithAccommodation] = useState(0)
  const [showMap, setShowMap] = useState(false)
  const [sortBy, setSortBy] = useState(['random', ''])
  const [activeTab, setActiveTab] = useState(null)
  const { setModal, modal } = useModal()
  const { apiUrl, cdnUrl } = useContext(ApiContext)

  const filterUnavailable = (unfiltered) => {
    return unfiltered.filter((h) => {
      let returnIndx = false
      let childrenAllowed = false;
      for (const room of h.rooms) {
        // console.log(room, searchParams.guests)
        if (room.price && room.price.length > 0) {
          for (const price of room.price) {
            if (price.amount) {
              const startDate = moment(price.startDate)
              const endDate = moment(price.endDate)
              if (
                startDate &&
                endDate &&
                moment(searchParams.checkinDate).isSameOrAfter(startDate) &&
                moment(searchParams.checkoutDate).isSameOrBefore(endDate)
              ) {
                returnIndx = true
              } else if (
                moment(searchParams.checkinDate).isSameOrAfter(startDate) &&
                moment(searchParams.checkoutDate).isSameOrAfter(endDate) &&
                moment(endDate).isSameOrAfter(moment(searchParams.checkinDate))
              ) {
                returnIndx = true
              }
            }
          }
          // now check if the room has enough beds for the guests
          if (returnIndx) {
            for (const guests of searchParams.guests) {
              let children = 0;
              let childGuests = 0;
              for (const pax of guests.paxes) {
                if (pax.age <= 13) {
                  childGuests += 1
                }
                if (room.children && room.children > 0 && room.maxAge) {
                  children += pax.age <= room.maxAge ? 1 : 0
                }
              }
              if (children <= room.children && childGuests <= room.children && childGuests <= children) {
                childrenAllowed = true
              }
            }
          }
        }
      }
      if (!childrenAllowed) {
        returnIndx = false
      }
      return returnIndx
    })
  }
  const filterAdults = (unfiltered, guests) => {
    const filtered = unfiltered.filter((h, j) => {
      let allowed = true
      if (h.adultsOnly) {
        for (const g of guests) {
          for (const pax of g.paxes) {
            if (pax.age < 18) {
              allowed = false
            }
          }
        }
      }
      return allowed
    })
    return filtered
  }
  useEffect(() => {
    if (newSearch) {
      setLoading(true)
      axios({
        method: 'post',
        url: '/api/stays',
        data: searchParams,
      }).then((response) => {
        setLoading(false)
        if (
          searchParams.checkinDate &&
          searchParams.checkoutDate &&
          moment(searchParams.checkinDate).format('YYYY-MM-DD') !==
            moment().add(1, 'day').format('YYYY-MM-DD')
        ) {
          setResults([
            ...filterAdults(
              [
                ...filterUnavailable(
                  setBasePrice(
                    response.data.nonApiHotels,
                    moment(searchParams.checkinDate),
                    moment(searchParams.checkoutDate)
                  )
                ),
                ...setBasePrice(
                  mapApiHotels(
                    response.data.tgHotels,
                    response.data.apiHotels,
                    hotels
                  ),
                  moment(searchParams.checkinDate),
                  moment(searchParams.checkoutDate)
                ),
              ],
              searchParams.guests
            ),
          ])
        } else {
          setResults([
            ...filterAdults(
              [...setBasePrice(response.data.allHotels, null, null)],
              searchParams.guests
            ),
          ])
        }
      })
    }
  }, [newSearch])

  const toggleMap = (evt: React.ChangeEvent<HTMLInputElement>) => {
    setShowMap(evt.target.checked)
  }

  const toggleFilters = () => {
    setOpenFilters(!openFilters)
  }

  const toggleSort = (evt) => {
    const option = evt.target.value.split('-')
    setSortBy(option)
  }

  const tabCount = (filterTab) => {
    const filtered = filterHotels(
      results,
      searchParams.filterArea.length > 0
        ? searchParams.filterArea.map((area) => area.name)
        : [],
      searchParams.filterType.length > 0
        ? searchParams.filterType.map((type) => type.name)
        : [],
      filterTab
    )
    return filtered.length
  }
  const isFilterable = () => {
    let retVar = false
    for (const sFilter of searchParams.filterType) {
      const selectedType = filterTypes.filter(
        (filterType) =>
          filterType.id === sFilter.id || filterType.name === sFilter.name
      )
      if (selectedType.length > 0) {
        retVar = true
      }
    }
    return retVar
  }
  return (
    <>
      {loading && <Loading />}
      {!loading && (
        <>
          <Wrapper background={'white'} noMargin={!mobile} smallMargin={mobile}>
            <Container maxWidth={'lg'}>
              <Grid container spacing={3} justify={'center'}>
                <Grid item xs={12}>
                  <div className={classes.filter}>
                    <div className={classes.tabsWrapper}>
                      <div
                        className={`${classes.tab} ${
                          activeTab === null ? classes.activeTab : ''
                        } ${results.length === 0 ? classes.disabledTab : ''}`}
                      >
                        <button
                          tabIndex={-1}
                          type="button"
                          role="tab"
                          aria-selected={activeTab === null}
                          id={`tab-all`}
                          onClick={() => setActiveTab(null)}
                          disabled={results.length === 0}
                        >
                          All <span>({tabCount(null)})</span>
                        </button>
                      </div>
                      {filterTabs &&
                        filterTabs.map((tab, i) => {
                          if (!tab.hasOwnProperty('id'))
                            return <React.Fragment key={i}></React.Fragment>
                          const resultsCount = tabCount(tab)
                          return (
                            <div
                              className={`${classes.tab} ${
                                activeTab && tab.id === activeTab.id
                                  ? classes.activeTab
                                  : ''
                              } ${
                                resultsCount === 0 ? classes.disabledTab : ''
                              }`}
                              key={i}
                            >
                              <button
                                tabIndex={-1}
                                type="button"
                                role="tab"
                                aria-selected={
                                  activeTab && tab.id === activeTab.id
                                }
                                id={`tab-${i}`}
                                onClick={() => setActiveTab(tab)}
                                disabled={resultsCount === 0}
                              >
                                {tab.name} <span>({resultsCount})</span>
                              </button>
                            </div>
                          )
                        })}
                    </div>
                    <div className={classes.filterOptions}>
                      <div
                        className={`filter-button ${classes.filterButton} ${
                          searchParams.filterType &&
                          searchParams.filterType.length > 0 &&
                          isFilterable()
                            ? classes.filterSelected
                            : ''
                        }`}
                      >
                        <span
                          onClick={() => {
                            setModal({
                              title: 'Filters',
                              content: (
                                <Filters
                                  types={filterTypes}
                                  areas={filterAreas}
                                  onClose={() => {
                                    setModal()
                                  }}
                                />
                              ),
                            })
                          }}
                        >
                          {searchParams.filterType &&
                          searchParams.filterType.length > 0 &&
                          isFilterable()
                            ? 'Edit'
                            : 'Add'}{' '}
                          filters <FontAwesomeIcon icon={faPlus} />
                        </span>
                      </div>
                      <span className={classes.filterLabel}>Sort By:</span>
                      <div className={`filter-button ${classes.filterButton}`}>
                        {sortBy[0] === 'random' && <>Default</>}
                        {sortBy[0] === 'price' && (
                          <>
                            Price -{' '}
                            {sortBy[1] === 'asc'
                              ? 'Low to High'
                              : 'High to Low'}
                          </>
                        )}
                        {sortBy[0] === 'rating' && (
                          <>
                            Rating -{' '}
                            {sortBy[1] === 'asc'
                              ? 'Low to High'
                              : 'High to Low'}
                          </>
                        )}
                        {sortBy[0] === 'alphabetical' && (
                          <>
                            Name - {sortBy[1] === 'asc' ? 'A to Z' : 'Z to A'}
                          </>
                        )}{' '}
                        <FontAwesomeIcon icon={faChevronDown} />
                        <select onChange={toggleSort}>
                          <option value="price-asc">Price - Low to High</option>
                          <option value="price-desc">
                            Price - High to Low
                          </option>
                          <option value="rating-asc">
                            Rating - Low to High
                          </option>
                          <option value="rating-desc">
                            Rating - High to Low
                          </option>
                          <option value="alphabetical-asc">
                            Name - A to Z
                          </option>
                          <option value="alphabetical-desc">
                            Name - Z to A
                          </option>
                        </select>
                      </div>
                      <span className={classes.filterLabel}>Map View:</span>
                      <div className={classes.filterCheckbox}>
                        <input type="checkbox" onChange={toggleMap} />
                        <div className={classes.icon}>
                          <FontAwesomeIcon icon={faCheck} />
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Container>
          </Wrapper>
          <Wrapper
            background={'lightGold'}
            noMargin
            flexGrow={results && results.length === 0}
          >
            <Container maxWidth={!showMap ? 'lg' : 'xl'}>
              <Grid
                container
                spacing={3}
                justify={'center'}
                className={classes.mapGrid}
              >
                <Grid item xs={12} lg={!showMap ? 12 : 7}>
                  {results && results.length > 0 && (
                    <div
                      className={`${showMap ? 'with-map ' : ''}${
                        classes.cardList
                      }`}
                    >
                      <Sortable
                        sortBy={sortBy}
                        hotels={results}
                        showMap={showMap}
                        areas={
                          searchParams.filterArea.length > 0
                            ? searchParams.filterArea.map((area) => area.name)
                            : []
                        }
                        types={
                          searchParams.filterType.length > 0
                            ? searchParams.filterType.map((type) => type.name)
                            : []
                        }
                        activeTab={activeTab}
                      />
                    </div>
                  )}
                </Grid>
                {showMap && (
                  <Grid item xs={12} lg={5}>
                    <div className={classes.sticky}>
                      <Locations
                        places={filterHotels(
                          results,
                          searchParams.filterArea.length > 0
                            ? searchParams.filterArea.map((area) => area.name)
                            : [],
                          searchParams.filterType.length > 0
                            ? searchParams.filterType.map((type) => type.name)
                            : [],
                          activeTab
                        )}
                      />
                    </div>
                  </Grid>
                )}
              </Grid>
            </Container>
          </Wrapper>
        </>
      )}
    </>
  )
}
export default Search
